import { useContext } from 'react';
import { SessionContext } from '@/providers/session-provider';
const useSession = () => {
  const ctx = useContext(SessionContext);
  if (!ctx) {
    throw new Error("useSession must be used within SessionProvider");
  }
  return ctx;
};
export default useSession;